import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "col ml-3" }
const _hoisted_3 = { class: "timeline-content d-flex" }
const _hoisted_4 = { class: "card-body py-3" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0\"><h3 class=\"card-title align-items-start flex-column\"></h3><div class=\"card-toolbar\"><div class=\"d-flex align-items-center position-relative my-1\"><button class=\"btn btn-sm btn-success me-3\" type=\"button\" data-bs-toggle=\"modal\" data-bs-target=\"#kt_modal_datacollect\"> Tambah Pengumpulan Data </button></div></div></div>", 1)
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "File Input"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Kreator"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Penanggung Jawab"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center col-md-3" }, "Note"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/edit.svg",
  alt: ""
}, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_datacollect",
  ref: "uploadModalRef"
}
const _hoisted_26 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_27 = { class: "modal-content rounded" }
const _hoisted_28 = { class: "modal-header pb-0 border-0 justify-content-center" }
const _hoisted_29 = {
  key: 0,
  class: "modal-title mb-6"
}
const _hoisted_30 = {
  key: 1,
  class: "modal-title mb-6"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
], -1)
const _hoisted_32 = { class: "modal-body scroll-y px-10 px-lg-15 pt-0 pb-15" }
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-xl-6 mb-8" }
const _hoisted_35 = { class: "row-xl-6 mb-8" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Kreator", -1)
const _hoisted_37 = { class: "row-xl-6 mb-8" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Penanggung Jawab", -1)
const _hoisted_39 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_40 = { class: "fv-help-block" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "row-xl-6 mb-8" }
const _hoisted_43 = { class: "form-label fw-bolder required text-dark fs-6 mr-3" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("File Upload ")
const _hoisted_45 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_46 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_47 = { class: "fv-help-block" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = {
  key: 2,
  class: "row mt-2"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1)
const _hoisted_52 = { class: "col" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = { class: "col-xl-6 mb-8" }
const _hoisted_55 = { class: "row-xl-6 mb-8" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required text-dark fs-6" }, "Tanggal", -1)
const _hoisted_57 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_58 = { class: "fv-help-block" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "row-xl-6 mb-8" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Catatan", -1)
const _hoisted_62 = { class: "modal-footer" }
const _hoisted_63 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _hoisted_8,
              (_ctx.data.tableDataCollect.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.tableDataCollect, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item.progressDate), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(item.uploadedFileName), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(item.creatorName), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.actorName), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(item.note.length > 50
                        ? item.note.substring(0, 50) + " ..."
                        : item.note), 1),
                        _createElementVNode("td", _hoisted_15, [
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            "data-bs-toggle": "tooltip",
                            title: "Edit",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.getId(item))
                          }, _hoisted_18, 8, _hoisted_16),
                          _createElementVNode("a", {
                            class: "symbol symbol-35px me-2",
                            "data-bs-toggle": "tooltip",
                            title: "Hapus",
                            style: {"cursor":"pointer"},
                            onClick: ($event: any) => (_ctx.handleDelete(index, item))
                          }, _hoisted_21, 8, _hoisted_19)
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_22, _hoisted_24))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                (_ctx.items.aksi == 'ubah')
                  ? (_openBlock(), _createElementBlock("h5", _hoisted_29, " Update Pengumpulan Data "))
                  : (_openBlock(), _createElementBlock("h5", _hoisted_30, "Tambah Pengumpulan Data")),
                _hoisted_31
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_Field, {
                        disabled: "",
                        type: "text",
                        name: "creatorName",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Kreator",
                        modelValue: _ctx.items.creatorID,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.items.creatorID) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_37, [
                      _hoisted_38,
                      _createVNode(_component_Field, {
                        type: "text",
                        name: "actorName",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Penanggung Jawab",
                        modelValue: _ctx.tambahDataCollect.actorName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambahDataCollect.actorName) = $event))
                      }, null, 8, ["modelValue"]),
                      (
                        _ctx.tambahDataCollect.actorName == '' ||
                        _ctx.tambahDataCollect.actorName == null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.items.erroractorName), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("label", _hoisted_43, [
                        _hoisted_44,
                        (_ctx.items.file != '' && _ctx.items.file != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_45, " File Tersedia "))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(), _createElementBlock("input", {
                        name: "file",
                        type: "file",
                        id: "file",
                        class: "form-control form-control-lg",
                        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleFileUpload($event))),
                        key: _ctx.items.fileInputKey
                      }, null, 32)),
                      (_ctx.items.file == '' || _ctx.items.file == null)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.items.errorfile), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48)),
                      (_ctx.items.aksi == 'ubah')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _hoisted_50,
                            _hoisted_51,
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-warning btn-sm",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadDL(_ctx.index, _ctx.item))),
                                disabled: _ctx.items.disableButton
                              }, " Download ", 8, _hoisted_53)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _createVNode(_component_Field, {
                        type: "date",
                        name: "progressDate",
                        class: "form-control form-control-lg",
                        placeholder: "Isi Tanggal",
                        modelValue: _ctx.tambahDataCollect.progressDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.tambahDataCollect.progressDate) = $event))
                      }, null, 8, ["modelValue"]),
                      (
                        _ctx.tambahDataCollect.progressDate == '' ||
                        _ctx.tambahDataCollect.progressDate == null
                      )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.items.errorprogressDate), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_59))
                    ]),
                    _createElementVNode("div", _hoisted_60, [
                      _hoisted_61,
                      _withDirectives(_createElementVNode("textarea", {
                        class: "form-control form-control-lg",
                        type: "text",
                        placeholder: "Isi Catatan",
                        name: "note",
                        autocomplete: "off",
                        rows: "10",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tambahDataCollect.note) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.tambahDataCollect.note]
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.kosongkanVariabel()))
                }, " Batal "),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submitAdd())),
                  disabled: _ctx.items.disableButton
                }, " Simpan ", 8, _hoisted_63)
              ])
            ])
          ])
        ], 512)
      ])
    ])
  ], 64))
}